import { render, staticRenderFns } from "./ProductImageThumbnail.vue?vue&type=template&id=a8bdb9ee&scoped=true"
import script from "./ProductImageThumbnail.vue?vue&type=script&lang=js"
export * from "./ProductImageThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ProductImageThumbnail.vue?vue&type=style&index=0&id=a8bdb9ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bdb9ee",
  null
  
)

export default component.exports